import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  C8_P1_S1_Title: {
    id: `case01.page01.slide01.title`,
  },
  C8_P1_S1_Description: {
    id: `case01.page01.slide01.description`,
  },
});
